export const getRandomizedLoadingCaption = (): string => {
  const captionLoadingPlaceholders = [
    window.i18next.t('pmwjs_sm_publishing_caption_loading_1'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_2'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_3'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_4'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_5'),
  ];

  const randomNumber = Math.floor(Math.random() * 5);
  return captionLoadingPlaceholders[randomNumber];
};
